import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";


import LoginReg from "./LoginReg";
import axios from "axios";
import ToastMessage from "./ToastMessage";
import toast from "react-hot-toast";
import "../index.css"
import { useTheme } from "../context/ThemeContext";
import { IoIosArrowDown } from "react-icons/io";
import { PiMagnifyingGlassPlusBold } from "react-icons/pi";
import { FaHome } from "react-icons/fa";
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { Button, Checkbox } from 'antd';
import { LuMenu } from "react-icons/lu";
import { AuthContext, base_url } from "../context/Authcontext";
import cricketRules from "./data/CricketRules.json";



export const Header = ({ isSidebar, setSidebar, refreshHeader, show, handleClose, handleShow }) => {
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const activeOneClickBtn = useRef(null);
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);
  const {
    logout,
    login,
    isAuthenticated,
    userBalnc,
    userInfo,
    userdata,


  } = useContext(AuthContext);

  const [sidebaar, setsidebaar] = useState(false);
  const [activeLink, setActiveLink] = useState("reports");
  const [isOneClickBet, setIsOneClickBet] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [liability, setLiability] = useState('0');
  const [aviator, setAviator] = useState();
  const [ludo, setLudo] = useState();
  const [toastActive, setToastActive] = useState(false);
  const [myInviteCode, setInviteCode] = useState();
  const [login_count, setTotalLogin] = useState();
  const isMobile = useIsMobile();
  // const { theme, handleThemeChange } = useTheme();
  const [loading, setLoading] = useState(true);
  const [logoPath, setLogoPath] = useState('');
  const [showInput, setShowInput] = useState(false);


  const [showMenu, setShowMenu] = useState(false);
  const [showMenuSm, setShowMenuSm] = useState(false);
  const menuRef = useRef();
  const menuSmRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenuSm(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const showLogo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/fetchLogoAction', {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data.data.result[0];

      if (data && data.logo_image) {
        setLogoPath(data.logo_image); // example: '/payment/logo123.jpg'
      }

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showLogo();
  }, []);


  useEffect(() => {
    const loadCasinoHistory = async () => {
      const gameToken = localStorage.getItem("game_token");
      if (!gameToken) return;

      try {
        // ✅ WAIT for insert API to finish
        await axios.get(base_url + "/api/webapi/casinoHistory", {
          params: { gameToken },
          withCredentials: true,
        });

        // ✅ NOW fetch DB data
        const response = await axios.get(
          base_url + "/api/webapi/myCasinoHistory",
          { withCredentials: true }
        );


      } catch (error) {
        console.log(error);
      }
    };

    loadCasinoHistory();
  }, []);


  const handleClicktoast = () => {
    toast.success("Coming soon");
  };

  const [hovered, setHovered] = useState(null);

  const handleMouseEnter = (key) => setHovered(key);
  const handleMouseLeave = () => setHovered(null);

  const isHovered = (key) => hovered === key;

  const isSmallScreen = window.innerWidth <= 768;
  const topValue = location.pathname === '/'
    ? 98
    : isSmallScreen
      ? 0
      : !isAuthenticated
        ? 98
        : 79;
  const styles = {
    radheExchange: {
      display: isSmallScreen ? 'block' : 'none',
      fontFamily: 'Roboto Condensed, sans-serif',
      position: 'sticky',
      top: 0,
      zIndex: 99,
      width: '100%'
    },
    radheExchange2: {
      display: isSmallScreen ? 'none' : 'block',
      fontFamily: 'Roboto Condensed, sans-serif',
      // position: 'sticky',
      // top: 0,
      // zIndex: 99,
      width: '100%'
    },
    marqueeDiv: {
      backgroundColor: themeColors['--dark-theme-dark-blue-variant'],
    },
    headerContainer: {
      backgroundColor: "#08c",
      color: 'white',
      padding: isSmallScreen ? "5px 5px 1px 2px" : "0px 5px"
    },
    aviator: {
      position: 'absolute',
      display: 'flex',
      fontSize: '8px',
      top: isSmallScreen ? '3px' : '-10px',
      left: isSmallScreen ? '16px' : "15px",
      height: "20px"
    },
    menuItemStyle: {
      padding: ".25rem 1rem",
      fontSize: "15px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      color: '#333',
    },
    navItemsLanding: {
      position: 'relative',
      padding: isSmallScreen ? '4px' : '16px 7px',
      top: isSmallScreen ? '0px' : '0px',
      height: isSmallScreen ? '' : "40px",
    },
    navLanding: {
      // position: 'sticky',
      // top: topValue,
      width: isSmallScreen ? '100%' : '100%',
      height: isSmallScreen ? '140px' : '40px',
    },
    demoAccountDiv: {
      position: 'relative',
    },
    demoAccountBtn: {
      backgroundColor: themeColors['--dark-theme-demoaccount'],
      color: themeColors['--dark-theme-color-navbar'],
      position: 'absolute',
      bottom: isSmallScreen ? 46 : 21,
      border: 'none',
      right: isSmallScreen ? 16 : 152,
      borderRadius: '4px',
      width: isSmallScreen ? '145px' : '150px',
      paddingTop: isSmallScreen ? '3px' : '7px',
      fontSize: isSmallScreen ? '10px' : '12px',
      fontWeight: 'bold',
      fontFamily: 'Roboto Condensed, sans-serif',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
    },
    accountInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isSmallScreen ? 'flex-end' : "flex-start",
    },
    login: {
      background: themeColors['--dark-theme-button-special'],
      width: isSmallScreen ? '78px' : "90px",
      borderRadius: isSmallScreen ? '8px' : '10px',
      fontSize: isSmallScreen ? '12px' : '14px',
      padding: isSmallScreen ? '3px 0px' : '8px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-data-bg'],
      fontWeight: 'bold',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    balanceBox: {
      background: themeColors['--dark-theme-button-special'],
      width: isSmallScreen ? '78px' : "100px",
      borderRadius: isSmallScreen ? '5px' : '7px',
      fontSize: isSmallScreen ? '12px' : '14px',
      padding: isSmallScreen ? '0px 3px' : '1px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-color-navbar'],
      fontWeight: '500',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    expBox: {
      background: themeColors['--dark-theme-button-special'],
      marginTop: '2px',
      borderRadius: isSmallScreen ? '5px' : '7px',
      fontSize: isSmallScreen ? '12px' : '14px',
      width: isSmallScreen ? '78px' : "100px",
      padding: isSmallScreen ? '0px 3px' : '0px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-color-navbar'],
      fontWeight: '500',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    spanBox: {
      fontSize: isSmallScreen ? '12px' : '14px',
    },
    textNowrapSm: {
      overflowX: 'auto',
      display: 'flex',
      padding: isSmallScreen ? '0px' : '5px 0px',
      width: isSmallScreen ? '100%' : '85%',
      gap: isSmallScreen ? '13px' : '',
    },
    textNowrap: {
      overflowX: 'auto',
      display: 'flex',
      padding: isSmallScreen ? '4px' : '0px',
      width: isSmallScreen ? '50%' : '60%',
      gap: isSmallScreen ? '13px' : '',
    },
    dates: {
      fontSize: isSmallScreen ? "11px" : '12px',
      color: themeColors['--dark-theme-color-navbar'],
    },
    offcanvas_menu: {
      color: themeColors['--dark-theme-color-navbar'],
    },
    reactIcon: {
      height: "19px",
      width: "19px",
      fontWeight: 'bold',
      marginRight: isSmallScreen ? '2px' : '',
    }
  }

  const [checked, setChecked] = useState(true);
  const [checked2, setChecked2] = useState(true);
  const onChange = e => {
    console.log('checked = ', e.target.checked);
    setChecked(e.target.checked);
  };
  const onChange2 = e => {
    console.log('checked2 = ', e.target.checked);
    setChecked2(e.target.checked);
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 3 } })} className='underlineHover' style={styles.menuItemStyle}>
          Account Statement
        </a>
      ),
      key: '0',
    },
    // {
    //   label: (
    //     <a onClick={() => navigate("/sports_bets", { state: { activeTab: 0 } })} className='underlineHover' style={styles.menuItemStyle}>
    //       Current Bet
    //     </a>
    //   ),
    //   key: '1',
    // },
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 1 } })} className='underlineHover' style={styles.menuItemStyle}>
          Casino Bet
        </a>
      ),
      key: '2',
    },
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 8 } })} className='underlineHover' style={styles.menuItemStyle}>
          Activity Logs
        </a>
      ),
      key: '3',
    },
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 9 } })} className='underlineHover' style={styles.menuItemStyle}>
          Casino Result
        </a>
      ),
      key: '4',
    },
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 7 } })} className='underlineHover' style={styles.menuItemStyle}>
          Current Bet
        </a>
      ),
      key: '5',
    },
    {
      label: (
        <>
          <a className='underlineHover' style={styles.menuItemStyle}>
            Balance
          </a>
          <Checkbox className="black-checkbox" style={{ paddingLeft: "53px" }} checked={checked} onChange={onChange}/>
        </>
      ),
      key: '6',
    },
    {
      label: (
        <>
          <a className='underlineHover' style={styles.menuItemStyle}>
            Exposure
          </a>
          <Checkbox
            className="black-checkbox"
            style={{ paddingLeft: "43px" }}
            checked={checked}
            onChange={onChange}
          />

        </>
      ),
      key: '7',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a className='underlineHover' style={styles.menuItemStyle} onClick={() => {
          setsidebaar(false);
          logout();
        }}>
          SignOut
        </a>
      ),
      key: '8',
    },
  ];


  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  const handleHamburger = () => {
    setSidebar(prev => !prev);
    if (isMobile) setsidebaar(false);
  };

  const handleSettings = () => {
    setsidebaar(prev => !prev);
    if (isMobile) setSidebar(false);
  };

  useEffect(() => {
    if (sidebaar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebaar]);
  useEffect(() => {
    if (isSidebar && isMobile) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isSidebar]);


  const handleClick = (linkName) => {
    setActiveLink((prev) => (prev === linkName ? null : linkName));
  };
  const handleOneClickBtn = (e) => {
    e.preventDefault();
    document.querySelector('.active_one_click')?.classList.remove('active_one_click');
    if (activeOneClickBtn.current) {

      activeOneClickBtn.current.classList.remove("active_one_click");
    }
    e.target.classList.add("active_one_click");
    activeOneClickBtn.current = e.target;

  }

  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "9999999999",
    password: "123456",
    iAcceptAll: true,
  });

  const submitlogin = (e) => {
    e.preventDefault();
    //  if (!loginFormData.phoneNumber || !loginFormData.password) {
    //    ToastMessage(0, "All fields are required!");
    //    return;
    //  }
    //  if (!/^\d{10}$/.test(loginFormData.phoneNumber)) {
    //   ToastMessage(0, "PhoneNumber should be 10 digits");
    //   return;
    // }
    //  if(!loginFormData.iAcceptAll){
    //    ToastMessage(0,"Please Accept The Terms And Conditions");
    //    return;
    //  }
    let { iAcceptAll, ...data } = loginFormData;
    login(data, function (res) {
      if (res.status) {

        ToastMessage(1, res.message);

        setactive(false);
        setregactive(false);
        navigate('/');

      } else {
        ToastMessage(0, res.message);
      }
    });
  };


  const allowedPaths = [
    "/home",
    "/cricketBet",
    "/sportall",
    "/cricketreal",
    "/footballreal",
    "/tennisreal",
    "/inplay",
    "/casinoGames",
  ];


  //  handle bonus
  // const handleClaimBonus = async () => {
  //   try {
  //     if (userBal.bonus === 0) {
  //       return;
  //     }
  //     const TotalUpdatedMoney = parseInt(userBal.userTotalBal) + (70 / 100) * userBal.bonus;
  //     const user_phone = userid.userPhone;

  //     const res = await axios.post(`${base_url}/api/webapi/admin/updateBonus`,
  //       { TotalUpdatedMoney, user_phone },
  //       {
  //         withCredentials: true,
  //         headers: {
  //           Accept: 'application/json'
  //         }
  //       }
  //     )

  //     if (res?.success) {
  //       setRefresh(!refresh);
  //       ToastMessage(1, res.message);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }


  // const handleSubmit = async () => {
  //   const token = localStorage.getItem('game_token');
  //   try {
  //     const response = await axios.post(base_url + '/api/webapi/casinoLobby', { token },
  //       {
  //         withCredentials: true,
  //         headers: {
  //           'content-type': 'application/json',
  //         }
  //       }
  //     )

  //     // console.log('lobby',response);
  //     if (response?.data.success) {
  //       window.location.href = response?.data.url;
  //     } else {
  //       toast.error(response?.data.message);
  //     }

  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  const handleGames = async () => {
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params: {
          token,
          provider: 'SPB',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);
      const games = response?.data?.items;

      const avia = games?.filter(game => game?.name.includes('Aviator'));
      // console.log('aviator',avia[0]);
      const id = avia[0]?.id;
      setAviator(id);

    } catch (err) {
      console.log(err);
    }
  }

  const handleGames1 = async () => {
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params: {
          token,
          provider: 'JIL',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);

      const games = response?.data?.items;

      const avia = games?.filter(game => game?.name.includes('Ludo'));
      // console.log('ludo',avia[0]);
      const id = avia[0]?.id;
      setLudo(id);
    } catch (err) {
      console.log(err);
    }
  }

  const openGameById = async (gameId) => {
    console.log('id', gameId);
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.post(base_url + '/api/gamelaunch/url',
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          }
        }
      )

      // console.log('url response',response);
      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;

      } else {
        toast.error('Please Login to Play.');
        setactive(true);
      }


    } catch (err) {
      console.log(err);
    }
  }

  // useEffect(() => {
  //   if (!isAuthenticated || !userInfo) return;

  //   setuserid({
  //     nameUser: userInfo.nameUser,
  //     userPhone: userInfo.userPhone,
  //     userName: userInfo.userName,
  //   });
  // }, [isAuthenticated, userInfo]);




  // const userAmount = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${base_url}/api/webapi/GetUserInfo`,
  //       {},
  //       { withCredentials: true, headers: { 'content-type': "application/json" } }
  //     );
  //     const data = response.data;
  //     setUserBal({ userTotalBal: data.data.money_user, bonus: data.bonus_money || 0 });
  //   } catch (error) {
  //     console.error("User data error:", error.message);
  //   }
  // };

  // useEffect(() => {
  //   userAmount();
  // }, []) 



  useEffect(() => {
    const LiabilityBalance = async () => {
      try {
        const response = await axios.get(`${base_url}/get/liability`, {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        });

        if (response?.data?.data?.totalLiability) {
          setLiability(response?.data?.data?.totalLiability);
        } else {
          setLiability('0');
        }
      } catch (error) {
        setLiability('0');
      }
    };

    // Call immediately on mount
    // LiabilityBalance();
    handleGames();
    handleGames1();

    // Set up interval
    const interval = setInterval(() => {
      // LiabilityBalance();
    }, 5000);
    // 5 seconds

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);

  // console.log('ludo',ludo);


  // Add CSS to handle responsive design
  const addResponsiveCSS = () => {
    const css = `
    @media (max-width: 768px) {
      .betting-navbar .navbar-nav {
        flex-direction: column !important;
      }
      
      .account-info {
        justify-content: center !important;
        margin-top: 10px !important;
      }
      
      .header-container .row {
        flex-direction: row !important;
      }
      
      .header-container .col-md-4 {
        text-align: center !important;
      }
    }
  `;

    const styleElement = document.createElement('style');
    styleElement.innerHTML = css;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  };

  React.useEffect(() => {
    // Add responsive styles when component mounts
    const cleanup = addResponsiveCSS();

    // Remove styles when component unmounts
    return cleanup;
  }, []);

  const isHomePage = location.pathname === '/';

  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (sidebaar) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [sidebaar]);

  // current date and time
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedDate = currentTime.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });

  const formattedTime = currentTime.toLocaleTimeString('en-GB');


  return (
    <>

      <style>{`
  .navItems-landingSm[_ngcontent-jrx-c95]:hover {
    color: skyblue;
    background-color: transparent !important;
  }
  .offcanvas-header .btn-close {
  filter: brightness(0) invert(1);
    height: 25px;
    width: 20px;
    opacity: var(--bs-btn-close-focus-opacity);
}
  .btn-close {
    --bs-btn-close-bg: url(https://png.pngtree.com/png-vector/20220628/ourmid/pngtree-icon-close-button-incorrect-forbidden-png-image_5286028.png) !important;
    background-size: 100% 100% !important;
  }
  .user_tabs p{
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
        color: themeColors['--dark-theme-color-navbar'];
  }
  .user_tabs p:hover {
    background-color: themeColors['--dark-theme-time-remaining'];
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .rules {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
  }
  .btn-close{
    position: relative;
    top: 0px;
    z-index: 99;
  }

  
.search-container {
  display: flex;
  align-items: center;
  margin-top: 6px !important;
  justify-content: flex-end;
  background-color: #08c;
  padding: 1px;
  border-radius: 4px;
  position: relative;
}
  
.search-container1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px;
  border-radius: 4px;
  position: relative;
}

.search-input-wrapper {
  overflow: hidden;
  width: 0;
  transition: width 0.4s ease;
}

.search-input-wrapper.show {
  width: 150px;
}

.search-input-wrapper1 {
  overflow: hidden;
  width: 0;
  transition: width 0.4s ease;
}

.search-input-wrapper1.show {
  width:135px;
}

.search-input {
  padding: 7px 12px;
  background-color: var(--dark-theme-color-navbar) !important;
  border: none;
  border-radius: 0px;
  outline: none;
  font-size: 14px;
  color: var(--dark-theme-white-color) !important;
  width: 100%;
  transition: all 0.4s ease;
}
.search-input::{
  color: var(--dark-theme-white-color) !important;
}

.search-icon {
  background-color: #08c;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 30px;
  margin-left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--dark-theme-color-navbar);
  font-size: 16px;
}

.search-icon:hover {
  background-color: #08c;
}

.header_items{
    display: flex;
    flex-direction: column;
    font-size: 15px;
    justify-content: center;
    line-height: 1.2;
}
         
  @media (max-width: 768px) {
    .navItems-landingSm[_ngcontent-jrx-c95]:hover {
      color: skyblue !important;
      background-color: transparent !important;
    }

    .navItems-landing[_ngcontent-jrx-c95] span[_ngcontent-jrx-c95]:hover {
      color: skyblue !important;
    }
    .header_items{
      font-size: 12px;
      align-items: end;
    }
    .search-input{
      padding: 3px 12px;
    }
    .underlineHover:hover{
        text-decoration: underline;
    }
  }
`}</style>
      {/* Small screen */}
      <div style={styles.radheExchange}>
        <div style={styles.headerContainer} className="header-container">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-6 col-6 mb-0 py-0 ps-0">
                <div _ngcontent-jrx-c79="" className="sidebar-header" style={{ display: "flex !important" }}>
                  <a
                    _ngcontent-jrx-c79=""
                    routerlink="/home"
                    className="d-flex align-items-center"
                    style={{ textDecoration: "none" }}
                    href="#"
                  >
                    {!isSidebar && location.pathname == "/home" && (
                      <Link
                        _ngcontent-mkq-c111=""
                        data-target="nav-mobile"
                        className="sidenav-trigger"
                        onClick={handleHamburger}
                      >
                        <LuMenu style={{ color: "white", fontSize: "26px", paddingRight: "2px" }} />
                      </Link>
                    )}
                    {location.pathname !== "/home" && (
                      <FaHome className="px-1" style={{ color: "white", fontSize: "31px" }} />
                    )}
                    <img
                      _ngcontent-jrx-c79=""
                      className="img-fluid top_dark"
                      style={{ width: "81px", height: "35px" }}
                      src="/assets/all_images/header/alllogo.png"
                      onClick={() => navigate("/home")}
                      alt="PrimeXexchange_logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-6 p-0 mb-0 pe-1">
                <div className="col-lg-5 mb-0 header_items px-0">
                  <p className="mb-2 me-0" style={{ display: checked ? "block" : "none" }} >Balance: <span className="fw-bold">{Number(userBalnc?.userTotalBal ?? 0).toFixed(2)}</span>
                  </p>
                  <div style={{ position: "relative", display: "inline-block" }} ref={menuSmRef}>
                    <div
                      onClick={() => setShowMenuSm(!showMenuSm)}
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        cursor: "pointer",
                        backgroundColor: "#08c",
                        padding: "0px",
                        display: "flex",
                        borderRadius: "4px",
                        fontSize: isSmallScreen ? "12px" : "14px",
                      }}>
                      <span className="my-auto me-1" style={{ display: checked2 ? "block" : "none" }}>Exp: <span className="fw-bold">{(liability) ? "" : ""}{liability}</span></span>
                      <Dropdown menu={{ items }}>
                        <a className="mb-1" onClick={(e) => e.preventDefault()}>
                          <Space style={{ color: "white", fontSize: '12px' }}>
                            {userInfo?.userName}


                            <DownOutlined style={{ color: 'white' }} />
                          </Space>
                        </a>
                      </Dropdown>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="px-0 d-flex ms-auto">
                <div className="search-container1 my-0">
                  <div className={`search-input-wrapper1 ${showInput ? "show" : ""}`}>
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search here"
                    />
                  </div>
                  <button
                    className="search-icon px-0"
                    onClick={() => setShowInput(!showInput)}
                  >
                    <PiMagnifyingGlassPlusBold style={{ height: "28px", width: "28px", color: themeColors['--dark-theme-color'], fontWeight: "bold" }} />
                  </button>
                </div>
                <marquee scrollamount="3" className='me-1 px-1' style={{ backgroundColor: "#ffffff45", height: '26px' }}>
                  <p className="mb-0 pt-1" style={{ fontSize: "13px", color: themeColors['--dark-theme-color-navbar'] }}><i>💥 Luck’s on fire—go scratch higher!🎉Wickets fall, jackpots call – Asia Cup magic beats them all! 🌟🏏.</i></p>
                </marquee>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={styles.radheExchange2}>
        <div style={styles.headerContainer} className="header-container">
          <div className="container-fluid px-0">
            <div className="row align-items-center">
              <div className="col-md-7 col-6 mb-0 py-1">
                <div _ngcontent-jrx-c79="" className="sidebar-header" style={{ display: "flex !important" }}>

                  <a
                    _ngcontent-jrx-c79=""
                    routerlink="/home"
                    className="d-flex align-items-center"
                    style={{ textDecoration: "none" }}
                    href="#"
                  >
                    <img
                      _ngcontent-jrx-c79=""
                      className="img-fluid top_dark"
                      style={{ width: "150px", height: "65px" }}
                      src="/assets/all_images/header/alllogo.png"
                      alt="PrimeXexchange_logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-5 col-6 px-0 mb-0 pt-0 pb-1">
                <div className="d-flex mt-0">

                  <div className=" px-0 ms-auto mb-0">
                    <div className="search-container my-0">
                      <div className={`search-input-wrapper ${showInput ? "show" : ""}`}>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search here"
                        />
                      </div>
                      <button
                        className="search-icon"
                        onClick={() => setShowInput(!showInput)}
                      >
                        <PiMagnifyingGlassPlusBold style={{ height: "35px", width: "35px", color: themeColors['--dark-theme-color'], fontWeight: "bold" }} />
                      </button>
                    </div>

                  </div>
                  <div className=" mb-0 px-0 ms-1 header_items">
                    {/* <p className="fw-bold mb-0"> Rules</p> */}



                    <div className=" mb-0 px-0 ms-1 header_items">
                      <p className="fw-semibold mb-0 cursor-pointer" style={{letterSpacing: '-1px'}} data-bs-toggle="modal" data-bs-target="#staticBackdrop"> Rules</p>
                      {/* <button type="button" class="btn btn-primary" >
                      Launch demo modal
                    </button> */}

                      <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog rules_dialog mt-0">
                          <div class="modal-content" style={{ width: '1140px' }}>
                            <div class="modal-header">
                              <h1 class="modal-title fs-5 fw-bold" id="staticBackdropLabel">Rules</h1>
                              <div className="ms-auto d-flex gap-1" style={{ padding: '6px 12px', backgroundColor: '#cccccc' }}>
                                <div>
                                  <img src="/assets/images/flag_english.png" style={{ height: '20px', width: '30px' }} />
                                </div>
                                <div>
                                  <p className="mb-0 text-dark fw-semibold">English</p>
                                </div>
                              </div>
                              {/* <div className="ms-auto d-flex gap-1 dropdown" style={{ backgroundColor: '#cccccc' }}>
                              <button class="btn dropdown-toggle" style={{backgroundColor: '#cccccc', padding: '6px 12px',}} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="/assets/images/flag_english.png" style={{ height: '20px', width: '30px' }} />
                                English
                              </button>
                              <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#">
                                  <img src="/assets/images/flag_english.png" style={{ height: '20px', width: '30px' }} />
                                English
                                  </a></li>
                              </ul>
                            </div> */}
                              <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body bg-white">
                              <div className="container-fluid">
                                <div className="row">
                                  <div class="d-flex align-items-start px-0" style={{ height: "491px", overflow: 'auto' }}>
                                    <div className="px-0" style={{ minWidth: '221px' }}>
                                      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                        <button class="nav-link rules_tabtn active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Football</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Horse Racing</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-egames-tab" data-bs-toggle="pill" data-bs-target="#v-pills-egames" type="button" role="tab" aria-controls="v-pills-egames" aria-selected="false" egames>E Games</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Basketball</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings" type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">MotoGP</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-chess-tab" data-bs-toggle="pill" data-bs-target="#v-pills-chess" type="button" role="tab" aria-controls="v-pills-chess" aria-selected="false">Chess</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-volleyball-tab" data-bs-toggle="pill" data-bs-target="#v-pills-volleyball" type="button" role="tab" aria-controls="v-pills-volleyball" aria-selected="false">Volleyball</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-hockey-tab" data-bs-toggle="pill" data-bs-target="#v-pills-hockey" type="button" role="tab" aria-controls="v-pills-hockey" aria-selected="false">Ice Hockey</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-tennis-tab" data-bs-toggle="pill" data-bs-target="#v-pills-tennis" type="button" role="tab" aria-controls="v-pills-tennis" aria-selected="false">Tennis</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-badminton-tab" data-bs-toggle="pill" data-bs-target="#v-pills-badminton" type="button" role="tab" aria-controls="v-pills-badminton" aria-selected="false">Badminton</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-cycling-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cycling" type="button" role="tab" aria-controls="v-pills-cycling" aria-selected="false">Cycling</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-material-tab" data-bs-toggle="pill" data-bs-target="#v-pills-material" type="button" role="tab" aria-controls="v-pills-material" aria-selected="false">Mixed Material Arts</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-motorbikes-tab" data-bs-toggle="pill" data-bs-target="#v-pills-motorbikes" type="button" role="tab" aria-controls="v-pills-motorbikes" aria-selected="false">Motorbikes</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-athletics-tab" data-bs-toggle="pill" data-bs-target="#v-pills-athletics" type="button" role="tab" aria-controls="v-pills-athletics" aria-selected="false">Athletics</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-basketball3x3-tab" data-bs-toggle="pill" data-bs-target="#v-pills-basketball3x3" type="button" role="tab" aria-controls="v-pills-basketball3x3" aria-selected="false">Basketball 3X3</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-sumo-tab" data-bs-toggle="pill" data-bs-target="#v-pills-sumo" type="button" role="tab" aria-controls="v-pills-sumo" aria-selected="false">Sumo</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-virtual-tab" data-bs-toggle="pill" data-bs-target="#v-pills-virtual" type="button" role="tab" aria-controls="v-pills-virtual" aria-selected="false">Virtual sports</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-handball-tab" data-bs-toggle="pill" data-bs-target="#v-pills-handball" type="button" role="tab" aria-controls="v-pills-handball" aria-selected="false">Handball</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-cricket-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cricket" type="button" role="tab" aria-controls="v-pills-cricket" aria-selected="false">Cricket</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-politics-tab" data-bs-toggle="pill" data-bs-target="#v-pills-politics" type="button" role="tab" aria-controls="v-pills-politics" aria-selected="false">Politics</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-golf-tab" data-bs-toggle="pill" data-bs-target="#v-pills-golf" type="button" role="tab" aria-controls="v-pills-golf" aria-selected="false">Golf</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-motor-tab" data-bs-toggle="pill" data-bs-target="#v-pills-motor" type="button" role="tab" aria-controls="v-pills-motor" aria-selected="false">Motor Sports</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-baseball-tab" data-bs-toggle="pill" data-bs-target="#v-pills-baseball" type="button" role="tab" aria-controls="v-pills-baseball" aria-selected="false">Baseball</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-union-tab" data-bs-toggle="pill" data-bs-target="#v-pills-union" type="button" role="tab" aria-controls="v-pills-union" aria-selected="false">Rugby Union</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-league-tab" data-bs-toggle="pill" data-bs-target="#v-pills-league" type="button" role="tab" aria-controls="v-pills-league" aria-selected="false">Rugby League</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-darts-tab" data-bs-toggle="pill" data-bs-target="#v-pills-darts" type="button" role="tab" aria-controls="v-pills-darts" aria-selected="false">Darts</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-american-tab" data-bs-toggle="pill" data-bs-target="#v-pills-american" type="button" role="tab" aria-controls="v-pills-american" aria-selected="false">American Football</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-snooker-tab" data-bs-toggle="pill" data-bs-target="#v-pills-snooker" type="button" role="tab" aria-controls="v-pills-snooker" aria-selected="false">Snooker</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-boxing-tab" data-bs-toggle="pill" data-bs-target="#v-pills-boxing" type="button" role="tab" aria-controls="v-pills-boxing" aria-selected="false">Boxing</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-soccer-tab" data-bs-toggle="pill" data-bs-target="#v-pills-soccer" type="button" role="tab" aria-controls="v-pills-soccer" aria-selected="false">Soccer</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-esports-tab" data-bs-toggle="pill" data-bs-target="#v-pills-esports" type="button" role="tab" aria-controls="v-pills-esports" aria-selected="false">Esports</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-greyhound-tab" data-bs-toggle="pill" data-bs-target="#v-pills-greyhound" type="button" role="tab" aria-controls="v-pills-greyhound" aria-selected="false">Greyhound Racing</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-kabaddi-tab" data-bs-toggle="pill" data-bs-target="#v-pills-kabaddi" type="button" role="tab" aria-controls="v-pills-kabaddi" aria-selected="false">Kabaddi</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-boat-tab" data-bs-toggle="pill" data-bs-target="#v-pills-boat" type="button" role="tab" aria-controls="v-pills-boat" aria-selected="false">Boat Racing</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-esoccer-tab" data-bs-toggle="pill" data-bs-target="#v-pills-esoccer" type="button" role="tab" aria-controls="v-pills-esoccer" aria-selected="false">Esoccer</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-wrestling-tab" data-bs-toggle="pill" data-bs-target="#v-pills-wrestling" type="button" role="tab" aria-controls="v-pills-wrestling" aria-selected="false">Wrestling</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-beach-tab" data-bs-toggle="pill" data-bs-target="#v-pills-beach" type="button" role="tab" aria-controls="v-pills-beach" aria-selected="false">Beach Volleyball</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-tabletennis-tab" data-bs-toggle="pill" data-bs-target="#v-pills-tabletennis" type="button" role="tab" aria-controls="v-pills-tabletennis" aria-selected="false">Table Tennis</button>

                                        <button class="nav-link rules_tabtn" id="v-pills-futsal-tab" data-bs-toggle="pill" data-bs-target="#v-pills-futsal" type="button" role="tab" aria-controls="v-pills-futsal" aria-selected="false">Futsal</button>
                                      </div>

                                    </div>

                                    <div className="px-0">
                                      <div class="tab-content" id="v-pills-tabContent">
                                        <div class="tab-pane fade m-0 show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">bookmaker</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If the match will not take place within 48 hours of the original kick-off time bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">If the selection is in a multiple bet or accumulator any refund must be requested before kick-off of the first leg of the multiple bet.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Please note that games which have their kick-off altered well in advance to accommodate live TV, or to ease fixture congestion will not be classed as postponed.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">If a match is forfeited or a team is given a walkover victory without the match having kicked off, then all bets will be void. Any subsequently awarded scoreline will not count for settlement purposes.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Where a confirmed postponed match features as part of a multiple bet, the bet will stand on the remaining selections in the multiple.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Tournament Total Goals, Team Total Goals goals. scored in 90 minutes or in extra-time will count.Goals scored in penalty shootouts do not count.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Tournament Corners - Only corners taken in 90 minutes count.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Tournament Penalties Missed/Converted - Penalties taken in 90 minutes, extra-time and penalty shootouts all count. If a penalty has to be re-taken the previous disallowed penalty(ies) do not count.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds :- All bets apply to the relevant full 'regular time' period including stoppage time. Any extra-time and/or penalty shoot-out is not included. For the cancellation of a goal, due to VAR, bets matched between the time of the goal being scored and the time at which the video assistant referee finishes the review will be voided. For the cancellation of a red card, due to VAR, bets matched after the time at which the video assistant referee commences the review will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Under_Over Goals :- In the event of a match starting but not being completed, all bets will be void, unless the specific market outcome is already determined,</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1st Period Winner :- Bets will be void if the match is abandoned before half-time.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Next Goal :- Own goals count to the side credited with the goal.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Draw No Bet :- Predict which team will be the winner. In case of a draw, all bets will be void. If a game is abandoned, bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Both Teams to Score :- Predict whether both teams will score at least one goal in the game. Own goals count towards the team credited with the goal. If a game is abandoned, bets will be void, unless the outcome of these bets is already determined. Yes” – meaning that both teams will score. “No” – meaning that either team will not score.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Total Corners :- Predict which team will take the named corner in the game. If this specific corner is not taken in the game, bets will be void. For example, game finishes or is abandoned with 8 corners taken – all bets on any corner after the 8th will be void (9th, 10th, etc.).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Goals Odd/Even :- Any match resulting in 0-0 will be settled on an even number of goals. For Team Odd/Even markets, if the specified team does not score then we will settle on an even number of goals. In the event of an abandoned match then bets for that match will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1X2 Corners :- Predict which team will get more corners in a match. Awarded, but not taken corners (there is a corner, but before it is taken the referee signals for the end of the first half or the match) will not count for settlement purposes. Also if a corner needs to be re-taken for any reason, it will be counted as 1 corner.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Under/Over Card in Match (Number of cards) :- Predict the number of the cards which will be shown in a match. If a player is sent off for 2 yellow cards, this counts as 2 yellow cards and 1 red card for betting purpose es. If the match is abandoned for any reason, all bets will be void unless market is already determined, e.g. Team 1 over 2,5 yellow cards - 3 yellow cards awarded to Team 1 before abandonment is settled as a winner. Cards for non-players (already substituted players, managers, players on bench which are not substituted in) are not considered. Settlement will be made with reference to all available evidence to cards shown during the scheduled 90 minutes play. Any card shown after the full-time whistle blow will be disregarded.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">HT/FT :- Bets will be void if the match is abandoned. Extra-time and penalty shootouts do not count.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">First Half Under/Over Goals :- How many goals will be scored in this first half of this match? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Penalty Taken? :- Will a penalty be awarded and taken during this match? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Correct Score :- Predict the score of this match. This market will not be partially settled during the fixture and will be fully settled at full time. All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Corners Number/Odds : - How many corners will be taken in the match? Only corners that are taken will be counted. All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Team_A/B +1/2/3 : - Who will win this match with the stated handicap applied? All bets apply to Full Time according to the match officials, plus any stoppage time. Extra-time/penalty shoot-outs are not included.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">“In the event of a technical error or any unforeseen circumstance that leads to the suspension of the Provider’s side of any market (Match_Odds,Over/Under, etc.) during a sporting event, and the market does not resume, the outcome will be settled based on the current result (win/loss) at the time of suspension. All bets placed prior to suspension will remain valid and will be settled accordingly. The company assumes no responsibility or liability for such interruptions or outcomes.”</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">1.General</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">All individual race markets will be determined according to the official result at the time of the 'weigh-in' announcement (or equivalent). Subsequent disqualifications, appeals or amendments to the result will be disregarded.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If a race is abandoned or otherwise declared void, or in the event of a walkover, all bets on that race will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If the scheduled venue is changed after the market has been loaded by us, all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Where a race does not take part on its scheduled day, all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If a scheduled surface type is changed (e.g. turf to dirt) all bets will stand.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">2.Non-Runner Rule</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Our's non-runner rule relates to the adjustment of odds on bets already matched when a horse in a race is declared a non-runner. In order to make the adjustment We applies a reduction factor to the remaining runners. The reduction factor allocated to a non-runner is a calculation (the details of which are described below) of that horse's chances of winning (or being placed, etc as appropriate) and is applied to bets already matched on the other runners in the relevant market or markets.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Any horse listed when the relevant market is loaded which does not subsequently come under starter's orders is deemed to be a non-runner.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">When the market is loaded each horse is given a 'reduction factor', based on a forecast price, which is expressed as a percentage. These reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately 15 minutes (approximately 5 minutes for Australian and US markets) from the scheduled 'off' time of a given race, they will be updated only in exceptional circumstances. The current reduction factor percentage for each horse can be viewed on the 'info' page on Our website or by asking the Helpdesk.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Accurate reduction factors will only be applied to selections in the event of a non-runner. Once a non-runner is declared each selection in the market will be given an appropriate reduction factor. Reduction factors can be amended at Our’s discretion at any time throughout the market life cycle (including post-race).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">For Australian racing, reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately five minutes from the scheduled off time of a given race they will be updated only in exceptional circumstances.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">For Australian racing, reduction factors may be updated periodically at the discretion of Us based on trading in the market, but after approximately five minutes from the scheduled off time of a given race they will be updated only in exceptional circumstances.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Reductions will be made to both win and place markets but applied differently (as described below), and horses will have a different reduction factor for each market.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">As soon as We becomes aware that a horse is an official non-runner or a highly likely non-runner, following a statement to the press from connections, the following will happen:</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">All matched bets on that horse will be void and the horse will be removed from the market.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the win market: if the reduction factor of the non-runner is 2.5% or greater, the traded price of all the matched bets on the remaining horses will be reduced by an amount equal to the non-runner's final reduction factor and all the unmatched offers to lay will be cancelled. If the non-runner's reduction factor is less than 2.5%, reductions will not be applied and unmatched bets will not be cancelled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the place market the reduction factor of all non-runners will be applied (even if less than 2.5%) and the potential winnings in relation to matched bets on the remaining horses will be reduced by an amount equal to the non-runner's final reduction factor. Only if the non-runner's reduction factor is 4.0% or greater will all the unmatched offers to lay be cancelled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">All the reduction factors on the remaining horses will be adjusted to reflect their improved chance of winning.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Reduction factors are not applied to bets which are struck in-play. However, if a market is turned in-play prematurely by error (or, for example, there is a false start), all bets matched during this time will be subject to any later reduction factor, provided the market is turned out of play before the race commences. In the event of a late withdrawal, We reserves the right to remove the runner after completion of the race. In this case only those bets matched prior to the off will be affected by a reduction factor.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the event of a non-runner being removed from a race in error or following incorrect information regarding a runner’s participation, we will reinstate both the runner and all previously matched bets associated with that runner. All bets made between the time of withdrawal and reinstatement will be void in both the place market and the win market. The reduction factor applied to matched bets at the time of withdrawal will be reversed and the original prices will become valid.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Any non-runners will be removed from the relevant markets in the order in which they are brought to Our's attention. If We becomes aware of more than one non-runner at the same time, it will remove the non-runners from the relevant markets in racecard order.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Any non-runners will be removed from the relevant markets in the order in which they are brought to Our's attention. If We becomes aware of more than one non-runner at the same time, it will remove the non-runners from the relevant markets in racecard order.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If a runner is not included in a market because of an error or because of incorrect information regarding a runner’s participation, We reserve the right to introduce the missing runner into the market at any time prior to settlement (even after the race has been run), provided that We are determined that the missing runner is not a material runner (i.e. a selection with a reduction factor of approx. 2.5% or less in the win market). In such circumstances, all pre-play unmatched and matched bets will stand, however if the runner is not introduced before the start of the race, all in-play bets will be void. However, if the missing runner is deemed to be a material runner, then the malformed market will be void and a new market will be loaded where possible.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">3.How the Reductions are applied for Exchange markets</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the win market, reductions will be made on the traded price. For example: if the non-runner's final reduction factor is 25% the traded price on all previously matched bets on other horses will be reduced by 25% - traded price of 8.0 would become 6.0 etc. And these might be further reduced if another horse is subsequently declared a non-runner.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the EW Market, reductions will be made on the traded win price. The advertised place terms will then apply to the revised win prices. For example: if the non-runner's final reduction factor is 25% the traded price on all previously matched bets on other horses will be reduced by 25% - - traded price of 8.0 would become 6.0. If the each Way terms were 1/5th odds for 3 places, the corresponding price for the Place portion of the bet would reduce from 2.4 to 2.0.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In the place market, reductions will be made to the potential winnings on the bet only, and not the traded price. For example: if the non-runner's final reduction factor is 25% the potential winnings on all previously matched bets on the other horses will be reduced by 25% - a traded price of 8.0 would become 6.25. For example a £10 bet on a horse to be placed at a traded price of 8.0 would provide winnings of £70. If there is a non-runner with a reduction factor of 25% in the race, that factor will be applied to the £70 of potential winnings leaving potential winnings of £52.50. Therefore the revised traded price will be 6.25.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">The traded price may be further reduced if any other horse(s) is subsequently declared a non-runner, however odds cannot be reduced below 1.01.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Reserves: A reserve runner may appear in the relevant markets but will have a non-applicable reduction factor until we are received confirmation that it is a confirmed runner, in which case an applicable reduction factor may apply to it.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">For the avoidance of doubt, any reduction factor applicable to a non-runner replaced by a reserve, will be applied to all bets struck on the relevant markets, prior to the removal from those markets of such non-runner by Us. Likewise, should a reserve runner become a confirmed runner but subsequently become a non-runner, any reduction factor applicable to such non-runner will be applied to all bets struck on the relevant markets, prior to the removal from those markets of such non-runner by Us.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">4.Additional rules</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Card numbers are posted as a guide only: bets are placed on a named horse.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Horses will not be coupled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Where any horse(s) runs for purse money only it is deemed a non-runner for betting purposes. Should this result in the number of possible winners stated in the relevant Market Information being equal to or greater than the number of runners in the relevant Betfair market, all bets in the market will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="tab-pane fade m-0" id="v-pills-egames" role="tabpanel" aria-labelledby="v-pills-egames-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">In the event of a match starting but not being completed, then all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds :- Predict which team will be the winner. There must be 5 minutes or less of scheduled game time left for bets to have action.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Quarter Winner :- The quarter must be completed for bets to have action, unless settlement of bets is already determined.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1st Half Winner / 2nd Half Winner :- The first half must be completed for first half bets to stand. If a game is postponed or cancelled after the start, for game and second half bets there must be 5 minutes or less remaining for bets to have action, unless settlement of bets is already determined. (Including Overtime if played.)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Highest Scoring Half :- Predict in which half most points will be scored. OT is not included in 2nd Half.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-chess" role="tabpanel" aria-labelledby="v-pills-chess-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-volleyball" role="tabpanel" aria-labelledby="v-pills-volleyball-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match odds :- Predict which team will be the winner. Bets will be void if the match is not completed.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Set Winner:- In the event of the set not being completed bets will be void. Exceptions are made for bets on sets which are already over, in this case the bets will be settled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-hockey" role="tabpanel" aria-labelledby="v-pills-hockey-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds Including overtime/shootouts :- Predict the winner of the match including overtime and penalties. The game must be completed for bets to have action.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Period Winner :- Predict the winner of the relevant period. The relevant period must be completed for bets to have action, unless the specific market outcome is already determined.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Highest Scoring Period:- If 2 or more periods have the same score Tie will be settled as the winner. (exclude overtime/shootouts for settlement purposes)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-tennis" role="tabpanel" aria-labelledby="v-pills-tennis-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">“In the event of a technical error or any unforeseen circumstance that leads to the suspension of the Provider’s side of any market (Match_Odds,Over/Under, Game Winner, Point Winner, etc.) during a sporting event, and the market does not resume, the outcome will be settled based on the current result (win/loss) at the time of suspension. All bets placed prior to suspension will remain valid and will be settled accordingly. The company assumes no responsibility or liability for such interruptions or outcomes.”</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds :-If 1st set has been not completed at the time of the retirement or disqualification, then all bets relating to that individual match will be void.after completion of 1st set in case of retirement the opponent player will be given the winner for match winner bets.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Game Winner :- Predict which player will win the stated game. The nominated game will be featured in the name of the bet type, for example: 2ndset – 7 th game – Winner. If a game is not completed for any reason, bets on it will be void. Tie break points will not be counted for this bet type. unless the specific market outcome is already determined.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Under / Over Games :- Finished set stand, the unfinished set can be played to its natural conclusion and settled as in the example: Example: A set is abandoned at 4-4 I win if I placed a bet on Over 9.5 (since any natural conclusion to the set would have at least 10 games); I lost the bet if I placed a bet on Under 9.5 (since any natural conclusion to the set would have at least 10 games); I get my stake back if I placed a bet on O/U 10.5 (it is undecided, the set could have ended 6-4).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-badminton" role="tabpanel" aria-labelledby="v-pills-badminton-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match_Odds:-Predict which player will win the match. In the event of any of the named players in a match changing before the match starts then all bets are void. In the event of a match starting but not being completed, then all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Set Winner:-The Set must be completed for bets to stand, unless the specific market outcome is already determined.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-cycling" role="tabpanel" aria-labelledby="v-pills-cycling-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-material" role="tabpanel" aria-labelledby="v-pills-material-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-motorbikes" role="tabpanel" aria-labelledby="v-pills-motorbikes-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-athletics" role="tabpanel" aria-labelledby="v-pills-athletics-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-basketball3x3" role="tabpanel" aria-labelledby="v-pills-basketball3x3-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-sumo" role="tabpanel" aria-labelledby="v-pills-sumo-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-virtual" role="tabpanel" aria-labelledby="v-pills-virtual-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-handball" role="tabpanel" aria-labelledby="v-pills-handball-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds:- Predict which team will be the winner. Bets will be void if the match is not completed.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Next Goal:- Predict which team will score the X-th goal.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Highest Scoring Half:- Predict which half will have the most goals scored (1st, 2nd or Draw). Bet will be settled on regulation time only and exclude overtime if played:</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Halftime/Fulltime:- Predict the result of a match at halftime and at the end of regular time. If a game is abandoned, bets will be void. Example: If you choose 1/X, you bet on the home team to lead in the first half and the match to end in a draw. Extra time doesn’t count.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-cricket" role="tabpanel" aria-labelledby="v-pills-cricket-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">bookmaker</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">1. Due to any reason any team will be getting advantage or disadvantage we are not concerned.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">4. Any query about the result or rates should be contacted within 7 days of the specific event, the same will not be considered valid post 7 days from the event.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">5. Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of vpn/robot-use/multiple entry from same IP/ multiple bets at the same time (Punching) and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">8. Super Over Bookmaker: If the scores are level at the end of both innings in the Super Over, the same market will continue into subsequent Super Overs until a winner is declared. (This rule applicable from 19th July 2025)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">9. In case technical error or any circumstances any bookmaker is suspended and does not resume result will be given all previous bets will be valid (based on haar/jeet).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">6. In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">7. If two team ends up with equal points, then result will be given based on the official point table</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">3. We will simply compare both teams 10 overs higher score team will be declared winner in T20 matches (If both teams same score means, low wickets team will be declared winner. In case, both teams same score & same wickets means highest boundaries team will be declared winner.If all same then will be declared No result)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">10. If a Match, Series, or League is postponed or rescheduled before any ball is bowled, all bets for that event will be voided. However, if play has already started and the match continues on a reserve day, then all bets will remain valid.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">11. If, for any reason, the trophy is shared between both teams, then all related bets will be voided.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              {cricketRules.rules.map((rule, index) => (
                                                <div key={index} className="rules_box">
                                                  <p className={`mb-0 p-2 text-${rule.type}`}>
                                                    {rule.text}
                                                  </p>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy1</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              {cricketRules.fancy.map((rule, index) => (
                                                <div key={index} className="rules_box">
                                                  <p className={`mb-0 p-2 text-${rule.type}`}>
                                                    {rule.text}
                                                  </p>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">cricket casino</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              {cricketRules.cricketCasino.map((rule, index) => (
                                                <div key={index} className="rules_box">
                                                  <p className={`mb-0 p-2 text-${rule.type}`}>
                                                    {rule.text}
                                                  </p>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              {cricketRules.match.map((rule, index) => (
                                                <div key={index} className="rules_box">
                                                  <p className={`mb-0 p-2 text-${rule.type}`}>
                                                    {rule.text}
                                                  </p>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">khado</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Only First inning valid for T20 and one day matches.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Same will be work like Lambi. If match abandoned or over reduced, all bets will be deleted.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">You can choose your own value in this event.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-politics" role="tabpanel" aria-labelledby="v-pills-politics-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2"> 1. This event is to decide the winner of various legislative assemblies of india.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">2. The final result declared by election commission of india for assembly elections of various states of india for a particular year will be valid in our exchange ,The customers are entirely responsible for their bets at all times.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">3. All bets will be voided if the election doesn't take place in given time by election commission or as per our exchange management decision.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">4. Company reserves the right to suspend/void any bets on this event at any time if we find the same not to be legitimate with the certainty of the outcome.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">5. Accidental issues during assembly elections will not be counted in our exchange If required Additional candidates may be added on request.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">6. Kindly be informed no candidates will be partially settled and will remain in the market until it is fully settled. This is to ensure that all customers can continue trading for the candidates that they have positions on, since each candidate is still a valid runner in this market.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">7. Please be informed that the transmissions described as "live" by few broadcasters may actually be delayed due to multiple scenarios.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">8. If any candidate withdraws for any reason, including death, all bets on the market will be valid and be settled as per the defined rules.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-golf" role="tabpanel" aria-labelledby="v-pills-golf-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-motor" role="tabpanel" aria-labelledby="v-pills-motor-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">bookmaker</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">All race bets are settled on the official classification from the Federation Internationale de l’Automobile (FIA),the sport’s governing body, at the time of podium presentation.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">If a race is postponed ( Either before the start or via an interruption mid-race) but is concluded within 72 hours of the original scheduled start time , then all bets will stand.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Our exchange management decision will be the final decision.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Any query about the result should be contacted within 7 days of the specific event, the same will not be considered valid post 7 days from the event.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-baseball" role="tabpanel" aria-labelledby="v-pills-baseball-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-union" role="tabpanel" aria-labelledby="v-pills-union-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-league" role="tabpanel" aria-labelledby="v-pills-league-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-darts" role="tabpanel" aria-labelledby="v-pills-darts-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-american" role="tabpanel" aria-labelledby="v-pills-american-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-snooker" role="tabpanel" aria-labelledby="v-pills-snooker-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match Odds:- Predict which player will win the match. In the event of a match starting but not being completed the player progressing to the next round or being awarded the victory will be deemed the winner for settlement purposes. In the event of a match not starting at all, all bets are refunded.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Frame Winner :- If the nominated frame is not played bets will be void. Similarly, if the nominated frame is awarded to a player without a shot being played, then all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-boxing" role="tabpanel" aria-labelledby="v-pills-boxing-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-soccer" role="tabpanel" aria-labelledby="v-pills-soccer-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-esports" role="tabpanel" aria-labelledby="v-pills-esports-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-greyhound" role="tabpanel" aria-labelledby="v-pills-greyhound-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-kabaddi" role="tabpanel" aria-labelledby="v-pills-kabaddi-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1. In any circumstances management decision will be final related to all Fancy of kabaddi of our exchange.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">2. All fancy bets will be validated when match has been tied.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">3. Result of individual player of fancy will be validated only when player play that match.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">4. In any case wrong rate has been given in fancy that particular bets will be deleted.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">5. Final Result Of 40 Minutes Of Two Halves Will Be Valid In Our Exchange</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">6. In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">7. If any player will get injured during the match, then all the bets will be valid of that individual player</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">bookmaker</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Final Result Of 40 Minutes Of Two Halves Will Be Valid In Our Exchange</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">In case, company will find Ground bets, Group betting, Punching bets, Multiple entries with same IP or any fraud or unusual activities are detected then Company will be void winning bets and charge penalty of 2X (Two times) from winning amount.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-boat" role="tabpanel" aria-labelledby="v-pills-boat-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-esoccer" role="tabpanel" aria-labelledby="v-pills-esoccer-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-wrestling" role="tabpanel" aria-labelledby="v-pills-wrestling-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">bookmaker</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Bookmaker (Virtual)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1. For Virtual events this refers to the outcome of the simulated match as determined by the game and the platform system.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">2. We Consider Winning Method Pin, Submission and Ring out. (Normal One – One Match).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">3. We Consider Player Taking Points Method Pin, Submission and Ring out. (For Ironman only).</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">4. In case technical error or any circumstances Bookmaker is suspended and does not resume result will be not given all bets will be deleted.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">5. If any case wrong rate has been given in that particular bets will be cancelled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">6. The winner will be the wrestler with most points, if both wrestlers have equal number of points the match will be drawn. (For Ironman Only)</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Normal (Virtual)</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">All Fancy Advance events will be suspended either 3 minutes after the match starts or as soon as any player scores the first point — whichever happens first.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">2. In case technical error or any circumstances Fancy is suspended and does not resume result will be not given all bets will be deleted.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">3. If any case wrong rate has been given in fancy that particular bets will be cancelled.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">4. We Consider Player Taking Points Method Pin, Submission and Ring out.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">5. Events are Player A Points, Player B Points and Total Match Points.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">6. Player A points Will be Result.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">7. Player B Points Will Be Result.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">8. Total Match Points are Consider Player A Points and Player B Points Will Be Result.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1. All fancy bets will be validated when match has been tied.</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">fancy1</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">All Fancy1 events will be suspended 10 minutes after the match begins.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-beach" role="tabpanel" aria-labelledby="v-pills-beach-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-tabletennis" role="tabpanel" aria-labelledby="v-pills-tabletennis-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Match odds :- Predict which player will win the match. In the event of any of the named players in a match changing before the match starts then all bets are void. In the event of a match starting but not being completed, all bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Set Winner :- The specified set must be completed for bets to stand, unless the specific market outcome is already determined.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Under / Over Points :- For example, a game is abandoned at 9-7: bets on Over/Under 16.5 Game - Total Points are settled as winners/losers respectively, since any natural conclusion to the game would have yielded at least 18 points.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="tab-pane fade m-0" id="v-pills-futsal" role="tabpanel" aria-labelledby="v-pills-futsal-tab" tabindex="0">
                                          <div>
                                            <div className="bg-black py-1 px-2">
                                              <h5 className="text-white my-1">match</h5>
                                            </div>
                                            <div className="m-2" style={{ border: '1px solid #c7c8ca' }}>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of VPN/robot-use/multiple entry from same or different IP and others. Note : only winning bets will be voided.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-danger mb-0 p-2">Match Odds:- Bets will be void if the match is not completed.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Next Goal :- Predict which team will score the X-th goal.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">1st Half Winner:- Half bets will be settled at the end of the 1 st half. In the event of a 1 st half not being completed bets will be void.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">Highest Scoring Half:- Predict in which Event Part will be scored most.</p>
                                              </div>
                                              <div className="rules_box">
                                                <p className="text-dark mb-0 p-2">for live streaming and animation :- Although the current score, time elapsed, video and other data provided on this site is sourced from "live" feeds provided by third parties, you should be aware that this data may be subject to a time delay and/or be inaccurate. Please also be aware that other customers may have access to data that is faster and/or more accurate than the data shown on the site. If you rely on this data to place bets, you do so entirely at your own risk. provides this data AS IS with no warranty as to the accuracy, completeness or timeliness of such data and accepts no responsibility for any loss (direct or indirect) suffered by you as a result of your reliance on it.</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer bg-white">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>




                    <p className="fw-semibold mb-0 ms-1" style={{letterSpacing: '-1px'}}> Download Apk
                      <span> </span>
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m10.213 1.471.691-1.26q.069-.124-.048-.192-.128-.057-.195.058l-.7 1.27A4.8 4.8 0 0 0 8.005.941q-1.032 0-1.956.404l-.7-1.27Q5.281-.037 5.154.02q-.117.069-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.7 3.7 0 0 0 3.5 5.02h9q0-1.125-.623-2.072a4.27 4.27 0 0 0-1.664-1.476ZM6.22 3.303a.37.37 0 0 1-.267.11.35.35 0 0 1-.263-.11.37.37 0 0 1-.107-.264.37.37 0 0 1 .107-.265.35.35 0 0 1 .263-.11q.155 0 .267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264m4.101 0a.35.35 0 0 1-.262.11.37.37 0 0 1-.268-.11.36.36 0 0 1-.112-.264q0-.154.112-.265a.37.37 0 0 1 .268-.11q.155 0 .262.11a.37.37 0 0 1 .107.265q0 .153-.107.264M3.5 11.77q0 .441.311.75.311.306.76.307h.758l.01 2.182q0 .414.292.703a.96.96 0 0 0 .7.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182q0 .414.292.703a.97.97 0 0 0 .71.288.97.97 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76q.436 0 .749-.308.31-.307.311-.75V5.365h-9zm10.495-6.587a.98.98 0 0 0-.702.278.9.9 0 0 0-.293.685v4.063q0 .406.293.69a.97.97 0 0 0 .702.284q.42 0 .712-.284a.92.92 0 0 0 .293-.69V6.146a.9.9 0 0 0-.293-.685 1 1 0 0 0-.712-.278m-12.702.283a1 1 0 0 1 .712-.283q.41 0 .702.283a.9.9 0 0 1 .293.68v4.063a.93.93 0 0 1-.288.69.97.97 0 0 1-.707.284 1 1 0 0 1-.712-.284.92.92 0 0 1-.293-.69V6.146q0-.396.293-.68"></path></svg>

                    </p>
                  </div>
                  <div style={styles.accountInfo} className="px-0 mb-0 mx-3 header_items">
                    <p className="mb-0" style={{ fontSize: "15px" }}>Balance: <span className="fw-bold">
                      {Number(userBalnc?.userTotalBal ?? 0).toFixed(2)}
                    </span></p>
                    <p className="mb-0" style={{ fontSize: "15px" }}>Exp: <span className="fw-bold">{(liability > 0) ? "-" : ""}{liability}</span></p>
                  </div>
                  <div className=" ps-0 mb-0 header_items">
                    <div className="me-auto" style={{ position: "relative", display: "inline-block" }} ref={menuRef}>
                      {/* Trigger */}
                      <div
                        onClick={() => setShowMenu(!showMenu)}
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          cursor: "pointer",
                          backgroundColor: "#08c",
                          padding: "0px 15px 0px 0px",
                          borderRadius: "4px",
                          fontSize: "14px",
                        }}
                      >
                        {userInfo?.userName}
                        <span><IoIosArrowDown style={styles.reactIcon} />
                        </span>
                      </div>

                      {showMenu && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: 22,
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                            minWidth: "180px",
                            zIndex: 1000,
                            marginTop: "4px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 3 } })} className='underlineHover' style={styles.menuItemStyle}>Account Statement</div>
                          {/* <div onClick={() => navigate("/sports_bets", { state: { activeTab: 0 } })} className='underlineHover' style={styles.menuItemStyle}>Sport Bets</div> */}
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 1 } })} className='underlineHover' style={styles.menuItemStyle}>Casino Bet</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 7 } })} className='underlineHover' style={styles.menuItemStyle}>Current Bet</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 8 } })} className='underlineHover' style={styles.menuItemStyle}>Activity Logs</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 9 } })} className='underlineHover' style={styles.menuItemStyle}>Casino Result</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 5 } })} className='underlineHover' style={styles.menuItemStyle}>Change Password</div>

                          {/* <div className='underlineHover' style={styles.menuItemStyle}>Set Button Values</div> */}
                          <hr style={{ margin: "5px 0", color: 'grey' }} />
                          <div className='underlineHover' style={styles.menuItemStyle} onClick={() => {
                            setsidebaar(false);
                            logout();
                          }}>SignOut</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* <marquee scrollamount="3">
                    <p className="mb-0" style={{ fontSize: "13px", fontWeight: "bold", color: themeColors['--dark-theme-color-navbar'] }}><i>💥 Luck’s on fire—go scratch higher!🎉Wickets fall, jackpots call – Asia Cup magic beats them all! 🌟🏏</i></p>
                  </marquee> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div _ngcontent-jrx-c95="" className="nav-landing d-lg-flex d-md-none d-none" style={{ ...styles.navLanding, zIndex: 99, display: !isAuthenticated && isSmallScreen ? 'none' : 'flex', }}>

          <div
            style={styles.textNowrap}

            className="text-nowrap"
          >
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted mb-2"
            >
              <span _ngcontent-jrx-c95="" className="my-auto"
                onMouseEnter={() => handleMouseEnter('home')}
                onMouseLeave={handleMouseLeave}
                onClick={() => navigate('/home')}
                style={{
                  ...styles.navItemsLanding,
                  borderBottom: isHovered('home')
                    && `2px solid ${themeColors['--dark-theme-color']}`
                }}>HOME</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('cricketreal')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('cricketreal')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate("/cricketreal")}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">CRICKET</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('FOOTBALL')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('FOOTBALL')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate("/footballreal")}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">FOOTBALL</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted"
              style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('tennisreal')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('tennisreal')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate('/tennisreal')}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">TENNIS</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('Horse')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Horse')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                navigate("/casinoGames", { state: { list: 17 } })
              }
            >
              <span _ngcontent-jrx-c95="" className="my-auto" > AE SEXY</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Greyhound')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Greyhound')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                navigate("/casinoGames", { state: { list: 10 } })
              }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">BACCARAT</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('IndianPoker')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('IndianPoker')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate('/casinoGames', { state: { list: 9 } })}
            >
              <span _ngcontent-jrx-c95="" className="my-auto" >ROULETTE</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Poker')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Poker')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                navigate("/casinoGames", { state: { list: 4 } })
              }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">TEENPATTI</span>
            </div>

            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('aeSexy')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('aeSexy')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate('/casinoGames', { state: { list: 14 } })}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">POKER</span>
            </div>

            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Evolution')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Evolution')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                navigate("/casinoGames", { state: { list: 16 } })
              }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">SLOTS</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, padding: "6px 0px", borderBottom: isHovered('Aviator')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Aviator')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                navigate("/casinoGames", { state: { list: 11 } })
              }
            >
              {/* <span _ngcontent-jrx-c95="" className="my-auto">AVIATOR</span> */}
              <svg style={{ transform: "rotate(10deg)" }} id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 457.6 277.4" className="blink_me"><defs><style>{`.cls-1 { fill: #e40539; }`}</style></defs><g id="Layer_1-2" data-name="Layer 1"><g><path className="cls-1" d="M61.85,273.4c-1.8-3.5-2.3-3.9-4-3-3.2,1.7-5.5,1.1-9-2.5l-3.3-3.4,4.4-1.9c2.4-1.1,8-2.2,12.4-2.6,27.1-2.5,84.1-19.2,161-47.1,32.1-11.7,80.4-30.1,81.3-31,1.2-1.2-1-1.5-11.9-1.7-10.6-.2-11.7,0-16.5,2.4-13.1,6.8-74.6,31.2-92.8,36.7l-6.9,2.1-6.4-5-6.5-4.9-3.6,1.5c-21.3,9-88,36.4-89.2,36.6-1,.2-1.6-.6-1.8-2.3-.3-2.4.5-3,7.8-6.9,4.5-2.3,7.9-4.5,7.5-4.8-.3-.4-4.3-.9-8.9-1.3-9.7-.8-17.3-4-28.2-11.9-4.8-3.5-7.8-5-10-5-4.3,0-6.4.9-6.4,2.7,0,.8,6.8,8.7,15.1,17.6,13,13.7,14.9,16.2,13.3,16.8-3.7,1.5-4.8.8-16.3-10.3-6.4-6.2-14.6-14.2-18.3-17.7l-6.7-6.5-8.8,4.2-8.8,4.2-.3-3.4c-.2-2,.2-4.4.8-5.5s6.5-4.8,13.1-8.2c11.8-6,14.2-8,12.2-10-.7-.7-4.1.5-10.2,3.5l-9.1,4.6v-2.5c0-2,1.4-3.3,7.7-7,10.3-6,17.3-8.1,22.3-6.6,2.1.6,10.7,6.3,19.1,12.6,19,14.3,29.4,19.9,35.9,19.2,5.3-.5,34-13.7,61.9-28.5,18.3-9.7,21.6-12.1,19.5-14.2-.7-.7-7.1,1.8-21.4,8.5-14.7,7-20.5,9.3-21.1,8.4-1.2-2-.1-3.3,5.6-6.3,3-1.6,5.5-3.4,5.5-4,0-.7-1.3-2.5-2.8-4l-2.9-2.7-19.8,9.6c-10.9,5.2-20,9.3-20.2,9.1-.8-.7,2.5-12.8,3.8-14.1.8-.8,9.5-5.6,19.4-10.8,17.7-9.4,18-9.6,17.8-12.7,0-1.7-.4-3.4-.7-3.7s-3.9.9-8,2.7l-7.4,3.3-8.9-9.3c-4.8-5.1-8.9-9.6-9.1-10-.5-1.4,8.8-7.9,14.6-10.1,10.4-4,10.9-3.9,118.5,11.3,35.6,5,65.5,9.7,66.5,10.4,1.6,1.1,1.6,1.4-.1,4.8l-1.7,3.7,2.8,1c1.5.5,5.8,2.1,9.5,3.6l6.9,2.5,10.1-4.3c12.4-5.2,32.9-15.6,45.6-23.2l9.4-5.5,3.2,2.4c3.2,2.4,6.9,3.1,7.9,1.6.3-.5-2.5-6.9-6.3-14.3-3.7-7.4-8.7-18.4-11-24.4-2.4-6.1-4.8-11.6-5.4-12.4-.9-1-3.3-1.2-10.7-.8-10.8.5-18.1,2.6-42,12-15.4,6-67.7,31.5-70.6,34.4-1.3,1.4-3.4,1.4-19.2-.1-9.7-.9-18-1.6-18.4-1.6-1.4,0-.8-5.5,1.1-9.7,1.6-3.4,3.9-5.4,14-12.1,14.3-9.5,28.2-16.5,37.4-18.9l6.5-1.7,9.9,3.9c14.3,5.6,16.3,5.6,39.8-1,38.2-10.6,43.5-11.8,52.2-11.9,8-.1,8.3,0,11.6,3.3,2.6,2.5,5.7,8.3,12,23,4.7,10.8,9,21.3,9.7,23.5,1.7,5.4.8,11.9-2.4,16-6.7,8.8-38,25.2-82.1,42.8-22.8,9.1-61.8,21.9-162.5,53.3-31.1,9.7-64.7,20.3-74.6,23.6-10,3.2-18.9,5.9-19.8,5.9-.8,0-2.5-1.8-3.6-4ZM291.35,168.4c3.8-2.3,7.1-6.9,5.8-8-.6-.5-144.9-20.8-158.8-22.3-1.2-.1-2,.4-2,1.3,0,1.2,15.5,4.6,72,16.1,39.6,8.1,73.7,14.7,75.9,14.8,2.3.1,5.2-.7,7.1-1.9h0ZM247.65,122c4.2-2.3,11.2-5.8,15.4-7.7,4.3-1.9,7.8-3.7,7.8-4.1s-2.8-1.3-6.2-2c-7.7-1.7-13.7-.9-22.4,3.3-6.7,3.1-18.9,11.7-18.1,12.6.6.5,9.3,1.9,13.5,2.2,1.3,0,5.8-1.9,10-4.3h0ZM282.15,115.8c7.5-3.8,10.7-6,10.5-7.1-.4-2.1-18.3-9.2-23.4-9.3-2.2,0-4.9.6-6,1.4q-2.1,1.6,10.4,6.5c2.6,1,4.8,2.3,5,2.9s-1.9,2.2-4.7,3.6c-5.5,2.8-6.6,4-5.7,6.1.8,2.3,2.3,1.9,13.9-4.1h0Z"></path><path className="cls-1" d="M440.55,196.2c-6.8-10.1-13.5-20.3-14.9-22.8-1.5-2.5-5.5-14.1-9.1-25.7l-6.5-21.3,5.1-5c2.7-2.8,5.1-4.9,5.2-4.8.1.2,5.2,9.4,11.4,20.6,11.9,21.3,15.8,31,23.1,58,3.3,11.9,3.3,12.3,1.7,15.7-.9,1.9-2.1,3.5-2.6,3.5s-6.5-8.2-13.4-18.2h0ZM454.65,206.5c.2-1.9-.5-4.6-1.7-6.7-1.8-3.1-22-30.4-24.3-32.9-1.2-1.3-3,1.5-2.2,3.5,1.2,3.4,26,39.9,26.9,39.6.6-.1,1.1-1.7,1.3-3.5h0Z"></path><path className="cls-1" d="M295.35,148.3c-13.2-2.6-24.6-4.9-25.4-5.1-.8-.2,11.3-5.4,27-11.6l28.3-11.4,5.3,5.9c2.9,3.2,5.2,6.3,5.3,6.9,0,.6-2.3,5.5-5.1,10.8-4.8,9.1-5.2,9.6-8.2,9.5-1.8-.1-14-2.3-27.2-5h0Z"></path><path className="cls-1" d="M334.85,152.1c0-.2,1.6-3.6,3.6-7.5,1.9-4,4.1-9,4.9-11.1l1.3-3.8-5.3-6.9c-5.3-6.8-5.4-6.9-3.2-8.1,2-1.1,2.6-.8,6.2,3.2,2.2,2.5,4.3,4.5,4.6,4.5s1.7-3.9,3-8.7l2.4-8.8.3,4.9c.2,2.6-.2,8-.8,11.8l-1,7,5.1,6.4,5.1,6.4-2.7,1c-2.2.9-2.9.6-5-1.8-1.3-1.5-2.5-3-2.5-3.4-.1-2.3-1.9-.1-3.9,4.6-1.2,3-2.8,5.9-3.5,6.5-1.4,1.1-8.6,4.3-8.6,3.8h0Z"></path><path className="cls-1" d="M404.75,114.7c-7.2-16.1-7.3-16.4-5.8-17.5,1.5-1,21.2-.4,24.2.7.9.4,1.7,1.4,1.7,2.2,0,4.2-12.6,21.3-15.6,21.3-.9,0-2.8-2.9-4.5-6.7h0ZM414.15,104.7c4.8-2,8.7-4,8.7-4.4,0-1.2-4.4-1.9-13.2-1.9-8.2,0-8.8.1-8.8,2,0,2.4,2.7,8,3.8,8,.4,0,4.6-1.6,9.5-3.7Z"></path><path className="cls-1" d="M385.05,75.9c-10.7-19.1-14-27.3-20.7-51.6-4-14.3-4.3-18.7-1.6-22l1.9-2.3,14.8,22.3,14.8,22.3,7.6,24.2c4.2,13.2,7.4,24.2,7.1,24.3-.3.1-3.5.3-7.1.6l-6.5.4-10.3-18.2h0ZM391.85,46.5c0-1.5-23.2-37.5-26.1-40.6-1.3-1.3-2.9,1.2-2.9,4.7,0,2.5,8.8,15.4,22.3,32.7,4.6,6,6.7,7,6.7,3.2Z"></path></g></g></svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


